import React from "react";
import "./chat-select-button.component.scoped.scss";
import { Button, Box, Typography } from "@material-ui/core";
import { icons } from "../../../../statics/icons";

interface ChatSelectButtonProps {
  option: {
    id: string;
    name: string;
    iconKey?: string;
    description?: string;
  };
  isSelected: boolean;
  isMultiple: boolean;
  onSelect: (option: any) => void;
  disabled?: boolean;
  faded?: boolean;
}

const ChatSelectButton: React.FC<ChatSelectButtonProps> = ({
  option,
  isSelected,
  isMultiple,
  onSelect,
  disabled = false,
  faded = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onSelect(option);
    }
  };

  const getIconSrc = () => {
    if (!option.iconKey) {
      return isSelected ? icons.categoryWhite : icons.categoryPrimary;
    }

    const iconKey = isSelected ? `${option.iconKey}_WHITE` : option.iconKey;

    return (
      icons.PAGES.SETTINGS.ICON_OPTIONS[iconKey] ||
      (isSelected ? icons.categoryWhite : icons.categoryPrimary)
    );
  };

  const hasIcon = option.iconKey || option.description; // Show icon if iconKey exists OR if there's a description
  const hasDescription = option.description;

  return (
    <Button
      className={`chat-select-button ${isSelected ? "selected" : ""} ${
        isMultiple ? "multiple" : "single"
      } ${hasIcon ? "with-icon" : ""} ${
        hasDescription ? "with-description" : ""
      }`}
      variant={isSelected ? "contained" : "outlined"}
      onClick={handleClick}
      disabled={disabled}
      style={faded ? { opacity: 0.5, pointerEvents: "none" } : {}}
    >
      <Box className="button-content">
        {hasIcon && (
          <img src={getIconSrc()} alt={option.name} className="option-icon" />
        )}
        <Box className="text-content">
          <Typography className="option-name">{option.name}</Typography>
          {hasDescription && (
            <Typography className="option-description">
              {option.description}
            </Typography>
          )}
        </Box>
      </Box>
    </Button>
  );
};

export default ChatSelectButton;
